import type { QueryClient } from '@tanstack/vue-query';
import { QueryKey } from '@/api/common/types/query-key.enum';

const refetchAll = { refetchType: 'all' as const };

/** Force-refresh group list, membership, and group leaderboard after invite accept. */
export const refreshStateAfterGroupInviteResponse = (queryClient: QueryClient, groupId: string) =>
  Promise.all([
    queryClient.invalidateQueries({ queryKey: [QueryKey.GetGroups], ...refetchAll }),
    queryClient.invalidateQueries({ queryKey: [QueryKey.GetLeaderboard], ...refetchAll }),
    queryClient.invalidateQueries({ queryKey: [QueryKey.GetGroupPosts, groupId], ...refetchAll }),
    queryClient.invalidateQueries({ queryKey: [QueryKey.GetChats], ...refetchAll }),
    queryClient.invalidateQueries({ queryKey: [QueryKey.GetAlerts], ...refetchAll }),
  ]);
